import React from "react";
import ReactDOM from "react-dom/client";
import { NuqsAdapter } from "nuqs/adapters/react";
import { TolgeeProvider } from "@tolgee/react";
import App from "./App";
import "./assets/css/ibm-plex-sans.css";
import "./assets/css/ibm-plex-sans-arabic.css";
import "./index.css";
import { StyledEngineProvider } from "@mui/material/styles";
import { tolgee } from "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <NuqsAdapter>
      <StyledEngineProvider injectFirst>
        <TolgeeProvider tolgee={tolgee}>
          <App />
        </TolgeeProvider>
      </StyledEngineProvider>
    </NuqsAdapter>
  </React.StrictMode>,
);
